const workflowTemplate = {
  id: null,
  name: null,
  typeId: null,
  typeName: null,
  clientId: null,
  clientName: null,
  isActive: true,
  defaultAdminUserId: null,
  defaultAdminUserName: null,
  dealAssignmentTypeMatch: null,
  contractTypeMatch: null,
  tasks: [],
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null
}

export default () => Object.assign({}, workflowTemplate)
